import { createAction, createReducer } from "redux-act";

export const updateAppUsers: any = createAction("app users - update");
export const updateAppDevices: any = createAction("app devices - update");

const defaultState: any = {
  wagz2: {
    users: [],
    devices: []
  },
  petzi: {
    users: [],
    devices: []
  },
  bd: {
    users: [],
    devices: []
  },
  bd2: {
    users: [],
    devices: []
  },
};

export default createReducer({
  /** should come in with app: and users: keys */
  [updateAppUsers]: (state, payload) => {
    const newState = { ...state };
    newState[payload.app].users = payload.users;
    return newState;
  },
  /** should come in with app: and devices: keys */
  [updateAppDevices]: (state, payload) => {
    const newState = { ...state };
    newState[payload.app].devices = payload.devices;
    return newState;
  },
}, defaultState);


// WEBPACK FOOTER //
// ./src/reducers/appUsersDevicesReducer.ts